import {Component} from '@angular/core';
import {NavController, AlertController, ToastController} from 'ionic-angular';
import {Api} from "../../providers/api";
import {LoginPage} from "../login/login";
import {MsgManager} from "../../providers/msg-manager";
import {GVLogger} from "../../services/gv-logger";


/*
 Generated class for the LoginPage page.

 See http://ionicframework.com/docs/v2/components/#navigation for more info on
 Ionic pages and navigation.
 */
@Component({
  selector: 'page-forgot-password',
  templateUrl: 'forgot-password.html'
})
export class ForgotPasswordPage {

  email:string;

  constructor(public nav: NavController,
    private alertController:AlertController,
    private api:Api,
    private toastController:ToastController,
    private msgManager:MsgManager,
    private gVLogger: GVLogger) {
  }

  // submit email
  send() {
    // enter your code here
    // back to login page
    this.nav.setRoot(LoginPage);
  }

  restPassword(){

    if(this.email == ""){
      this.presentAlert("Can't proceed","Please fill the form field to continue","ok");
    }else{
      // let body = new FormData();
      // body.append("email",this.email);

      let body = {email:this.email};

      this.api.getPassword("users/recoverPassword",body).map(res => res.json()).subscribe(res=>{
        if(res.status =="200"){
          this.msgManager.toastMsg(this.msgManager.getPasswordRestRequestSuccessMsg());

          this.nav.pop();
        }else if(res.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
          this.nav.setRoot(LoginPage);
        }else{
          this.presentAlert("Something went wrong",res.message,"ok");
        }
      })
    }

  }

  presentAlert(title,msg,buttonText) {
    let alert = this.alertController.create({
      title: title,
      subTitle: msg,
      buttons: [buttonText]
    });
    alert.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/forgot-password/forgot-password.ts